import React from 'react';
import PropTypes from 'prop-types';

import TableBody from '@material-ui/core/TableBody';

import OfferRow from './OfferRow';

const OfferBody = props => {
  const { data, columns, strings } = props;
  return columns.length > 0 ? (
    <TableBody>
      {data.map(row => (
        <OfferRow row={row} columns={columns} key={row.id} strings={strings} />
      ))}
    </TableBody>
  ) : undefined;
};

OfferBody.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    })
  ),
  columns: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    })
  ),
  strings: PropTypes.object.isRequired, // eslint-disable-line
};

OfferBody.defaultProps = {
  data: [],
  columns: [],
};

export default OfferBody;
